import React from "react";
import { withRouter } from "react-router-dom";
import { getUrl, Constants, getDateString, Analytics, slugify } from "../../utilities";
import { SVG } from "../../assets/images/svg";
import classnames from "classnames";
import "./MenuTab.scss";
import { DEFAULT_HEADERS } from "../../constants";

const MenuTab: React.FunctionComponent<any> = ({ navItem, location, history, className: customClassName, toggle, hideToggle }) => {
  const { name, target, image, children, showImage, onClick: customOnClick } = navItem;
  const className = classnames(
    "MenuTab",
    { selected: location && location.pathname.includes(target) },
    customClassName
  );

  const getLiveDetails = async() => {
    // VITE_NEW_MIDDLEWARE_URL
    const offsetInMinutes = new Date().getTimezoneOffset();
    let url = `${import.meta.env.VITE_NEW_MIDDLEWARE_URL}/schedules?type=now-next&date=${getDateString()}&platform=web&offset=${-offsetInMinutes}`;
    try {
      let res = await fetch( url,{
        method: "GET",
        headers: {
          ...DEFAULT_HEADERS,
          "content-type": "application/json",
          "x-platform": "WEB"
        }
      } );
      if ( res && res.ok ) {
        let data = await res.json();

        const filterData  = data.filter(item=>  item.now)
        return  filterData
      } else {
        console.log( "error occured" )
      }
    } catch ( error ) {
      console.log( error )
    }
  }

  const getNavigationTrackingData = (itemName: string):any => {
    const normalizedName = (itemName || "").trim().toLowerCase();
    if (normalizedName === "home") {
      return {
        context: "home",
        sectionName: slugify(itemName)
      };
    }
    if (normalizedName === "settings" || normalizedName === "sign in") {
      return {
        context: "more",
        sectionName: slugify(itemName)
      };
    }
    return {};
  };

  const onClick = async() => {
    if(name === Constants.Menu) {
      let data = await getLiveDetails()
      let liveIndex = navItem.children.findIndex(ele => ele.name === Constants.Live);
      if(liveIndex > -1) {
        navItem.children[liveIndex].children = data;
      }
    }
    if (name === Constants.Live) {
      let data = await getLiveDetails()
      navItem.children = data;
      toggle(navItem)
    } else {
      if (customOnClick) {
        // Track navigation click for custom onClick items (Settings, Sign In, etc.)
        if (target || name) {
          Analytics.userActionNavigation(name, target || "", getNavigationTrackingData(name));
        }
        customOnClick();
      } else if (children && children.length) {
        // Don't track when opening submenu - only track when submenu item is clicked
        toggle(navItem);
      } else {
        // Track navigation click for direct navigation items (no submenu)
        if (target || name) {
          Analytics.userActionNavigation(name, target || "", getNavigationTrackingData(name));
        }
        history.push(getUrl(target));
      }
    }
  }

  return (
    <div className={className} onClick={onClick}>
      { name === "Settings" ? <SVG.Settings></SVG.Settings> :
        showImage && image ?
        <img src={image.url} alt="icon" /> :
        <span>{name}</span>
      }
      { ((children && !hideToggle) || name === Constants.Live) && <span className="MenuTab__arrow" dangerouslySetInnerHTML={{__html: "&#9660;"}} /> }
    </div>
  )
};

export default withRouter(MenuTab);
